export default __webpack_public_path__ + "125ca8ee27bef3548acf1f65ac48fb3c.svg";